import React, { useRef } from "react";
import SwitchInput from "common/SwitchInputWithState";
import { getFormData, rankAndParseFields } from "./utils";

export const GreSettings = ({ onChange, defaults = {}, state = {}, bqn, metadata }) => {
  const form = useRef(null);
  const onInputChange = () => {
    const values = getFormData(form.current);
    onChange(rankAndParseFields(values, state));
  };
  return (
    <>
      <h2 className="card-inside-title">
        Basic GRE Support (no checksum, no key, no sequence)
      </h2>
      <form ref={form}>
        <SwitchInput
          defaultChecked={defaults.gre}
          className={"sw-input"}
          name={`gre[bqn ${bqn}]`}
          label="Get IP addresses from inside GRE tunnel"
          onChange={onInputChange}
          tooltipValues={metadata?.gre}
        />
      </form>
    </>
  );
};
